import {
  DefaultTriggeredPopupBadge,
  ETriggeredPopupBadgeInternalViewModel,
  PlaystudiosTriggeredPopupBadge
} from '@appcharge/shared-ui';

import { EThemes } from '../enums';

import { BlockMetadata } from './types';

const defaultTriggeredPopupBadge: BlockMetadata = {
  id: ETriggeredPopupBadgeInternalViewModel.DEFAULT,
  version: '1.0.0',
  name: 'Default',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: false,
  previewAssets: [],
  theme: EThemes.ROYAL_BLAST,
  component: DefaultTriggeredPopupBadge
};

const defaultKonamiSlotsTriggeredPopupBadge: BlockMetadata = {
  id: ETriggeredPopupBadgeInternalViewModel.KONAMI_SLOTS,
  version: '1.0.0',
  name: 'Konami Slots',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/popups/trigger-popup-badge-konami.png '
  ],
  theme: EThemes.PLAYSTUDIOS,
  component: PlaystudiosTriggeredPopupBadge
};

export const triggeredPopupsBadgesDesigns = {
  defaultTriggeredPopupBadge,
  defaultKonamiSlotsTriggeredPopupBadge
};

export const triggeredPopupsBadgesDesignsByTheme: Record<
  EThemes,
  BlockMetadata[]
> = Object.values(triggeredPopupsBadgesDesigns).reduce(
  (acc, design) => {
    if (!acc[design.theme]) {
      acc[design.theme] = [];
    }
    acc[design.theme].push(design);
    return acc;
  },
  {} as Record<EThemes, BlockMetadata[]>
);
